import Avatar from '@/features/avatar/Avatar';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface FriendsTableAvatarProps {
  id: string;
  alias: string;
  onClick?: (value: string) => void;
}

const FriendsTableAvatar: FC<FriendsTableAvatarProps> = ({ id, alias, onClick }) => {
  return (
    <div
      className={twMerge('flex items-center gap-2', onClick && 'cursor-pointer')}
      onClick={() => (onClick ? onClick(id) : null)}
    >
      <Avatar avatar2D round={false} className="h-10 w-10 rounded-lg border-2 border-ph-primary-violet" userId={id} />
      <span className="w-[50%] overflow-hidden text-ellipsis whitespace-nowrap text-sm text-white md:w-full md:text-base">
        {alias}
      </span>
    </div>
  );
};

export default FriendsTableAvatar;
